<template>
  <div class="login-page theme-audra">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="card login-box position-relative">
            <div class="overlay text-center" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div>
              <img :src="getImage('logo.svg')" alt="Dotlines" />
              <form
                @submit.prevent="reset_pass()"
                method="POST"
                class="response-alert"
                novalidate
              >
                <div class="form-group mb-3">
                  <label class="control-label">OTP Code</label>
                  <input
                    type="text"
                    name="otp_code"
                    v-model.trim="resetPassInfo.otp_code"
                    class="form-control"
                    placeholder="Reset OTP Code"
                    v-validate="'required'"
                    :class="{ 'has-error': errors.has('otp_code') }"
                  />

                  <div class="help text-danger" v-show="errors.has('otp_code')">
                    {{ errors.first("otp_code") }}
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label class="control-label"> New Password</label>
                  <div class="password">
                    <input
                      type="password"
                      name="password"
                      v-model.trim="resetPassInfo.password"
                      class="form-control"
                      placeholder="The password must be alphanumeric. Min: 6 Max: 20"
                      v-validate="'required'"
                      ref="password"
                      :class="{ 'has-error': errors.has('password') }"
                      :type="showPassword ? 'text' : 'password'"
                    />
                    <span class="password-toggle" @click="togglePassword">
                      <i
                        :class="{
                          'icon-eye-off': showPassword,
                          'icon-eye': !showPassword,
                        }"
                      ></i>
                    </span>
                  </div>
                  <div class="help text-danger" v-show="errors.has('password')">
                    {{ errors.first("password") }}
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label class="control-label">Confirm Password</label>
                  <div class="password">
                    <input
                      type="password"
                      name="password_confirmation"
                      v-model.trim="resetPassInfo.password_confirmation"
                      class="form-control"
                      placeholder="The Confirm Password should be same as New Password."
                      v-validate="'required|confirmed:password'"
                      data-vv-as="password"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      :class="{
                        'has-error': errors.has('password_confirmation'),
                      }"
                    />
                    <span class="password-toggle" @click="toggleConfirmPassword">
                      <i
                        :class="{
                          'icon-eye-off': showConfirmPassword,
                          'icon-eye': !showConfirmPassword,
                        }"
                      ></i>
                    </span>
                  </div>
                  <div
                    class="help text-danger"
                    v-show="errors.has('password_confirmation')"
                  >
                    {{ errors.first("password_confirmation") }}
                  </div>
                </div>

                <button type="submit" class="btn btn-common btn-block mb-4">
                  Reset Password
                </button>

                <div class="text-center">
                  <router-link
                    class="pc fw-500 align-items-center d-inline-flex"
                    :to="{ name: 'Login' }"
                  >
                    <i style="font-size: 24px" class="icon-arrow-left-circle mr-2"></i>
                    Back to login
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4 ml-auto d-none d-sm-block">
          <div class="login-img">
            <h2><span>Enterprise</span> Grade Internet <strong>Security</strong>.</h2>
            <img class="like" src="/assets/images/like.png" alt="like" />
            <img class="sheild" src="/assets/images/sheild.png" alt="sheild" />
            <img class="wifi" src="/assets/images/wifi.png" alt="wifi" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import router from "@/router";
import axios from "axios";
// import store from "@/store";

export default {
  components: {
    //
  },
  data: () => ({
    showPassword: false,
    showConfirmPassword: false,
    resetPassInfo: {
      send_via: "",
      mobile_or_email: "",
    },
    is_loading: false,
  }),
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    reset_pass: function (e) {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          const api_url = this.API_BASE_URL + "/auth/reset-password";
          this.is_loading = true;
          axios({
            method: "post",
            url: api_url,
            data: this.resetPassInfo,
          })
            .then(function (response) {
              console.log("check response", response);
              if (response.status === 200) {
                router.push({ path: "/login" });
              } else {
                $(".response-alert").prepend(
                  $(
                    '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                      "    Invalid username or password!\n" +
                      '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                      '       <span aria-hidden="true">&times;</span>\n' +
                      "    </button>\n" +
                      "</div>"
                  )
                );
              }
            })
            .catch(function (error) {
              if (error.response) {
                // Extract errors from response
                const msg = error.response.data.message;
                const errors = error.response.data.errors;
                let errorMessage = "";
                for (let field in errors) {
                  if (errors.hasOwnProperty(field)) {
                    errors[field].forEach((msg) => {
                      errorMessage += msg + "\n";
                    });
                  }
                }

                if (msg) {
                  errorMessage += msg + "\n";
                }

                errorMessage = errorMessage.replace(/<br\s*\/?>/gi, "\n");

                _this.$toaster.error(errorMessage.trim());

                // $(".response-alert").prepend(
                //   $(
                //     '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                //       errorMessage +
                //       '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                //       '       <span aria-hidden="true">&times;</span>\n' +
                //       "    </button>\n" +
                //       "</div>"
                //   )
                // );
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
              }
            })
            .finally(function () {
              _this.is_loading = false;
              _this.is_disabled = false;
              setTimeout(() => {
                $(".alert").fadeOut("slow");
              }, 5000);
            });
        }
      });
    },
  },
  mounted: function () {
    const params = this.$route.params;
    if (params !== undefined && Object.keys(params).length > 0) {
      this.resetPassInfo.send_via = params.userInfo.send_via;
      this.resetPassInfo.mobile_or_email = params.userInfo.mobile_or_email;
    } else {
      router.push({ path: "/login" });
    }
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
